/** Resolve a condo id from the URL only when it belongs to the loaded portfolio. */
export function resolveAccessibleCondoId(
  condoIdFromUrl: string | null | undefined,
  condos: ReadonlyArray<{ id: number }>
): number | null {
  if (condoIdFromUrl == null || condoIdFromUrl === "") {
    return null;
  }
  const condoId = Number.parseInt(condoIdFromUrl, 10);
  if (!Number.isFinite(condoId)) {
    return null;
  }
  return condos.some((condo) => condo.id === condoId) ? condoId : null;
}

/** True when a list fetch failed because the condo is outside the manager portfolio. */
export function isCondoAccessDeniedError(
  error: string | null | undefined
): boolean {
  if (!error) {
    return false;
  }
  return /do not have access to this condo|403:\s*You do not have access/i.test(
    error
  );
}
